import { Image } from "../../AbstractElements";
import logo from "../../assets/svgs/logo.svg";
import logo1 from "../../assets/svgs/logo.svg";
import { Link } from "react-router-dom";
import { useCustomContext } from "../../_helper/customizer";
import { Button } from "react-bootstrap";
import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowLeft01Icon } from "@hugeicons/core-free-icons";
import { useScreenSize } from "../../utils/hooks/useScreenSize ";
import { withTranslation } from "react-i18next";

const SidebarIcon = ({ t }) => {
  const { toggleSidebar } = useCustomContext();
  const { isMobile, isTablet } = useScreenSize();
  const openCloseSidebar = () => {
    toggleSidebar();
  };

  const isSmallScreen = isMobile || isTablet;
  return (
    <div className="logo-wrapper d-flex align-items-center">
      <div className="flex-fill d-flex gap-3 align-items-center">
        <Link to="/app">
          <Image
            attrImage={{
              className: "img-fluid for-light",
              src: `${logo}`,
              alt: "",
            }}
          />
          <Image
            attrImage={{
              className: "img-fluid for-dark",
              src: `${logo1}`,
              alt: "",
            }}
          />
        </Link>
        <span className="sst-arabic">{t("BRAND_NAME")}</span>
      </div>
      {isSmallScreen && (
        <Button
          className="btn-secondary btn-icon btn-xs"
          onClick={() => openCloseSidebar()}
        >
          <HugeiconsIcon size={14} icon={ArrowLeft01Icon} />
        </Button>
      )}
    </div>
  );
};
export default withTranslation()(SidebarIcon);
